import { render } from "./ManageObjectivesModal.vue?vue&type=template&id=10ed12f8&scoped=true&ts=true"
import script from "./ManageObjectivesModal.vue?vue&type=script&lang=ts"
export * from "./ManageObjectivesModal.vue?vue&type=script&lang=ts"

import "./ManageObjectivesModal.vue?vue&type=style&index=0&id=10ed12f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ed12f8"]])

export default __exports__